const constantsData = {
    admins: "Admins",
    canceled: "canceled",
    chunkLoadError: "ChunkLoadError",
    closeToastButtonClicked: "closeToastButtonClicked",
    dataOptionIndex: "data-option-index",
    duplicatedTrackIsrc: "A track with this ISRC already exists",
    duplicatedVideoIsrc: "A video with this ISRC already exists",
    failedToFetch: "Failed to fetch",
    file: "file",
    folder: "folder",
    group: "group",
    invalidDate: "Invalid Date",
    mena: "mena",
    networkError: "Network Error",
    networkErrorPatterns: ["Failed to fetch", "dynamically imported", "ERR_CONNECTION_REFUSED"],
    offline: "offline",
    offlineDescription: "Your Internet connection is unstable, please try again later or try another network",
    offlineTitle: "You are Offline",
    online: "online",
    organizer: "organizer",
    owner: "owner",
    preOrderWithIGT: "PRE_ORDER_WITH_IGT",
    releaseDetails: "releaseDetails",
    superAdmins: "Super Admins",
    token: "token",
    trackDetails: "trackDetails",
    ttmlXml: ".ttml.xml",
    user: "user",
    videoClip: "VIDEOCLIP",
    videoDistributionType: "VIDEO_DISTRIBUTION",
    videoWithoutLogo: "VIDEO WITHOUT LOGO",
    withLogo: "WITH LOGO",
    withoutLogo: "WITHOUT LOGO",
    ww: "ww",
};

export default constantsData;
